(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__asmBudgetEnforceInit) return;
  window.__asmBudgetEnforceInit = true;

  function enforceDesignHomeBudget(){
    var budgetInput = document.getElementById('dhBudget');
    if(!budgetInput) return;
    var budget = parseFloat(budgetInput.value);
    if(!budget || isNaN(budget)) return;
    document.querySelectorAll('.asm-dh-catblock-products').forEach(function(container){
      container.querySelectorAll('.asm-dh-prod-card').forEach(function(card){
        if(card.dataset.asmBudgetChecked) return;
        var priceEl = card.querySelector('.asm-dh-prod-price');
        if(!priceEl) return;
        var priceText = priceEl.textContent || '';
        var match = priceText.match(/[0-9.]+/);
        if(!match) return;
        var price = parseFloat(match[0]);
        card.dataset.asmBudgetChecked = '1';
        if(!isNaN(price) && price > budget){
          card.remove();
        }
      });
      if(container.dataset.asmEmptyChecked !== '1' && container.children.length === 0 && container.dataset.asmHadProducts === '1'){
        container.dataset.asmEmptyChecked = '1';
        container.innerHTML = '<div class=asm-dh-catblock-empty>لا توجد منتجات ضمن هذه الميزانية في هذا القسم حاليًا</div>';
      }
      if(container.children.length > 0){
        container.dataset.asmHadProducts = '1';
      }
    });
  }

  enforceDesignHomeBudget();
  setInterval(enforceDesignHomeBudget, 800);

  var cartSvg = '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.8"><path d="M3.4 6.9h13.2v8c0 .6-.2 1.1-.6 1.5-.4.4-.9.6-1.5.6H5.5c-.6 0-1.1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5z"/><path d="M8.8 3h2.3c.6 0 1.2.2 1.6.7.4.4.7 1 .7 1.6v1.6H6.5V5.3c0-.6.2-1.2.7-1.6.4-.5 1-.7 1.6-.7"/></svg>';
  var checkSvg = '<svg viewBox="0 0 20 20" fill="none" stroke-width="2"><path d="M4 10l4 4 8-8"/></svg>';

  function wireCartButtons(){
    document.querySelectorAll('.asm-card-cart-btn').forEach(function(btn){
      if(btn.dataset.asmCartWired) return;
      btn.dataset.asmCartWired = '1';
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.dataset.variantId;
        if(!variantId){
          window.location.href = btn.dataset.productUrl;
          return;
        }
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function(res){
          if(!res.ok){ throw new Error('add_failed'); }
          return res.json();
        })
        .then(function(){
          btn.innerHTML = checkSvg;
          btn.classList.add('asm-cart-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll('.asm-quicknav-cart-count, [data-cart-count], .cart-count, .cart-count-bubble').forEach(function(el){
              el.textContent = cart.item_count;
            });
          }).catch(function(){});
          setTimeout(function(){
            btn.innerHTML = cartSvg;
            btn.classList.remove('asm-cart-added');
            btn.disabled = false;
          }, 1600);
        })
        .catch(function(){
          btn.disabled = false;
        });
      });
    });
  }
  wireCartButtons();
  setInterval(wireCartButtons, 800);

  function getFavs(){ try{ return JSON.parse(localStorage.getItem('asm_favorites')||'[]'); }catch(e){ return []; } }
  function saveFavs(list){ try{ localStorage.setItem('asm_favorites', JSON.stringify(list)); }catch(e){} }

  function wireFavButtons(){
    document.querySelectorAll('.asm-card-fav-btn[data-handle]').forEach(function(btn){
      var h = btn.getAttribute('data-handle');
      if(!h) return;
      var active = getFavs().some(function(f){ return f.handle === h; });
      btn.classList.toggle('asm-fav-active', active);
      if(btn.dataset.asmWired) return;
      btn.dataset.asmWired = '1';
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var favs = getFavs();
        var idx = favs.findIndex(function(f){ return f.handle === h; });
        if(idx > -1){ favs.splice(idx,1); }
        else {
          favs.push({
            handle: h,
            title: btn.getAttribute('data-title') || h,
            image: btn.getAttribute('data-image') || '',
            price: btn.getAttribute('data-price') || ''
          });
        }
        saveFavs(favs);
        var nowActive = getFavs().some(function(f){ return f.handle === h; });
        btn.classList.toggle('asm-fav-active', nowActive);
      });
    });
  }
  wireFavButtons();
  setInterval(wireFavButtons, 800);

  function hideActionsOnCartPage(){
    if(window.location.pathname.indexOf('/cart') !== 0) return;
    document.querySelectorAll('.asm-card-actions-row').forEach(function(row){
      row.style.display = 'none';
    });
  }
  hideActionsOnCartPage();
  setInterval(hideActionsOnCartPage, 800);

  function initChatWidget(){
    if(window.__asmChatWidgetInit) return;
    var metaEl = document.getElementById('asm-customer-id');
    if(!metaEl) return; // wait until at least one product card has rendered
    window.__asmChatWidgetInit = true;

    var customerId = (metaEl.getAttribute('content') || '').trim();
    var WORKER_URL = 'https://aurasmart-ai-advisor.aloon42.workers.dev';
    var history = [];

    var chatSvg = '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><path d="M21 12c0 4.4-4 8-9 8-1.1 0-2.2-.2-3.2-.5L3 21l1.6-4.8C3.6 14.9 3 13.5 3 12c0-4.4 4-8 9-8s9 3.6 9 8z"/></svg>';
    var closeSvg = '×';
    var sendSvg = '<svg viewBox="0 0 20 20" fill="none" stroke-width="2"><path d="M2 10h16M18 10l-6-6M18 10l-6 6"/></svg>';

    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'asm-chat-fab';
    fab.setAttribute('aria-label', 'الدعم الفني الذكي');
    fab.innerHTML = chatSvg;
    document.body.appendChild(fab);

    var panel = document.createElement('div');
    panel.className = 'asm-chat-panel';

    if(!customerId){
      panel.innerHTML =
        '<div class="asm-chat-header"><b>الدعم الفني الذكي</b><button type="button" class="asm-chat-close">' + closeSvg + '</button></div>' +
        '<div class="asm-chat-locked">هذه الخدمة متاحة للأعضاء المسجّلين فقط.<br><a href="/account/login">سجّل الدخول</a> أو أنشئ حساب للاستفادة من الدعم الفني الذكي.</div>';
      document.body.appendChild(panel);
      fab.addEventListener('click', function(){ panel.classList.toggle('asm-open'); });
      panel.querySelector('.asm-chat-close').addEventListener('click', function(){ panel.classList.remove('asm-open'); });
      return;
    }

    panel.innerHTML =
      '<div class="asm-chat-header"><b>الدعم الفني الذكي</b><button type="button" class="asm-chat-close">' + closeSvg + '</button></div>' +
      '<div class="asm-chat-messages"></div>' +
      '<div class="asm-chat-inputrow">' +
        '<input type="text" placeholder="اكتب سؤالك هنا..." maxlength="500">' +
        '<button type="button" class="asm-chat-send">' + sendSvg + '</button>' +
      '</div>';
    document.body.appendChild(panel);

    var messagesEl = panel.querySelector('.asm-chat-messages');
    var inputEl = panel.querySelector('input');
    var sendBtn = panel.querySelector('.asm-chat-send');

    function addMsg(role, text){
      var div = document.createElement('div');
      div.className = 'asm-chat-msg ' + (role === 'user' ? 'asm-user' : 'asm-bot');
      div.textContent = text;
      messagesEl.appendChild(div);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function addTyping(){
      var div = document.createElement('div');
      div.className = 'asm-chat-msg asm-typing';
      div.textContent = 'يكتب الآن...';
      div.dataset.typing = '1';
      messagesEl.appendChild(div);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return div;
    }

    if(messagesEl.children.length === 0){
      addMsg('assistant', 'أهلًا بك! أنا المساعد الذكي لدعم AuraSmart Home. اسألني عن أي منتج، الشحن، الاسترجاع، أو أي استفسار ثاني 👋');
    }

    function sendMessage(){
      var text = inputEl.value.trim();
      if(!text) return;
      inputEl.value = '';
      addMsg('user', text);
      history.push({ role: 'user', content: text });
      sendBtn.disabled = true;
      var typingEl = addTyping();

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode: 'chat', customer_id: customerId, messages: history })
      })
      .then(function(res){ return res.json(); })
      .then(function(data){
        typingEl.remove();
        sendBtn.disabled = false;
        if(data.quota_exceeded){
          addMsg('assistant', data.error || 'وصلت للحد اليومي للأسئلة، حاول لاحقًا.');
          return;
        }
        if(!data.success){
          addMsg('assistant', 'عذرًا، صار خطأ تقني. حاول مرة أخرى أو تواصل معنا على info@aurasmarthome.net');
          return;
        }
        addMsg('assistant', data.reply);
        history.push({ role: 'assistant', content: data.reply });
      })
      .catch(function(){
        typingEl.remove();
        sendBtn.disabled = false;
        addMsg('assistant', 'تعذر الاتصال حاليًا. حاول مرة أخرى بعد قليل.');
      });
    }

    fab.addEventListener('click', function(){ panel.classList.toggle('asm-open'); });
    panel.querySelector('.asm-chat-close').addEventListener('click', function(){ panel.classList.remove('asm-open'); });
    sendBtn.addEventListener('click', sendMessage);
    inputEl.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ sendMessage(); }
    });
  }
  initChatWidget();
  setInterval(initChatWidget, 1000);

  function enhanceDesignHomeQuota(){
    var quotaBox = document.getElementById('asmDhQuota');
    var metaEl = document.getElementById('asm-customer-id');
    if(!quotaBox || !metaEl) return;
    var customerId = (metaEl.getAttribute('content') || '').trim();
    if(!customerId) return;

    function checkQuota(){
      fetch('https://aurasmart-ai-advisor.aloon42.workers.dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode: 'quota_check', customer_id: customerId })
      })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(!data.success) return;
        if(data.quota_remaining > 0){
          quotaBox.innerHTML = '<b style="color:#ffd700;font-size:14px;">لديك ' + data.quota_remaining + ' من 3 توصيات متبقية اليوم</b>';
        } else {
          quotaBox.innerHTML = '<b style="color:#ff6b6b;font-size:14px;">استخدمت توصياتك الثلاث لهذا اليوم — حاول بعد نحو ' + (data.reset_in_hours || 24) + ' ساعة</b>';
        }
      })
      .catch(function(){});
    }

    if(!quotaBox.dataset.asmEnhanced){
      quotaBox.dataset.asmEnhanced = '1';
      checkQuota();
    }

    var form = document.getElementById('asmDesignHomeForm');
    var resultBox = document.getElementById('asmDesignHomeResult');
    if(form && resultBox && !form.dataset.asmQuotaReminderWired){
      form.dataset.asmQuotaReminderWired = '1';
      form.addEventListener('submit', function(){
        setTimeout(function(){
          if(resultBox.querySelector('.asm-dh-quota-reminder')) return;
          var reminder = document.createElement('div');
          reminder.className = 'asm-dh-quota-reminder';
          reminder.style.cssText = 'color:#ffd700;font-weight:800;font-size:14px;text-align:center;margin-bottom:14px;border:1px solid #d4af37;padding:12px;border-radius:4px;line-height:1.7;';
          reminder.textContent = 'تذكير مهم: لديك 3 توصيات فقط كل 24 ساعة. تحديث الصفحة أو إعادة الإرسال أثناء انتظار النتيجة يُحتسب أيضًا كمحاولة.';
          resultBox.insertBefore(reminder, resultBox.firstChild);
        }, 30);
        setTimeout(checkQuota, 1800);
      });
    }
  }
  enhanceDesignHomeQuota();
  setInterval(enhanceDesignHomeQuota, 1000);

  function splitMenuArrowClick(){
    if(window.__asmMenuArrowInit) return;
    window.__asmMenuArrowInit = true;

    var ARROW_ZONE = 28; // px width reserved for the arrow hit-zone at the edge

    document.addEventListener('click', function(e){
      var link = e.target.closest('.menu-list__link[aria-haspopup="true"]');
      if(!link) return;

      var li = link.closest('.menu-list__list-item');
      if(!li) return;

      var rect = link.getBoundingClientRect();
      var x = e.clientX;
      var nearStart = (x - rect.left) <= ARROW_ZONE;
      var nearEnd = (rect.right - x) <= ARROW_ZONE;

      if(nearStart || nearEnd){
        // Clicked the arrow zone: toggle dropdown, do not navigate
        e.preventDefault();
        e.stopPropagation();
        var isOpen = li.classList.contains('asm-submenu-forced');
        document.querySelectorAll('.menu-list__list-item.asm-submenu-forced').forEach(function(openLi){
          if(openLi !== li){
            openLi.classList.remove('asm-submenu-forced');
            var otherLink = openLi.querySelector('.menu-list__link[aria-haspopup="true"]');
            if(otherLink) otherLink.setAttribute('aria-expanded', 'false');
          }
        });
        li.classList.toggle('asm-submenu-forced', !isOpen);
        link.setAttribute('aria-expanded', String(!isOpen));
      }
      // Otherwise: clicked the text itself, let the normal navigation happen
    }, true);

    document.addEventListener('click', function(e){
      if(e.target.closest('.menu-list__list-item.asm-submenu-forced')) return;
      document.querySelectorAll('.menu-list__list-item.asm-submenu-forced').forEach(function(openLi){
        openLi.classList.remove('asm-submenu-forced');
        var otherLink = openLi.querySelector('.menu-list__link[aria-haspopup="true"]');
        if(otherLink) otherLink.setAttribute('aria-expanded', 'false');
      });
    });
  }
  splitMenuArrowClick();
})();
  } catch(e) { console.error(e); }
})();

})();
